import React, { useState } from 'react';
import axios from 'axios';
import { getNBNApiHeader } from 'utlis/commonfunctions';



function OtpVerification({ visp_qualification_id, sessionId, onSuccessTap, onActiveSuccess, onBackClick, variable, userToken}) {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiKey = process.env.REACT_APP_API_TOKEN;
    const [otp, setOtp] = useState('');
    const [apiMessage, setApiMessage] = useState([]);
    const [apiStatus, setApiStatusCode] = useState('');
    const [apiCalled, setApiCalled] = useState(false);
    const [verificationSessionId, setSessionId] = useState();
    const [isOtpSection, setisOtpSection] = useState(false);
    const [isButtonDisable,setisButtonDisable] = useState(false);
    
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        visp_qualification_id: visp_qualification_id
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });

    };

    const handleBackClick = (e) => {
        e.preventDefault();
        onBackClick()
    }

const header = {
    'Authorization':'Bearer '+ sessionStorage.getItem('access_token'),
    'api-token': apiKey,
    'app_type' : "NBNRTAP",
    'Content-Type' : 'application/json'
};

    const handleSubmit = async(event) => {
        event.preventDefault();
        const headers = header;
        setisButtonDisable(true)
    
        axios.post(`${apiUrl}nbn/customer-mail-otp-send`, formData, {
            headers:headers
        })
        .then(response => {
            setApiCalled(true);
            if (response.status === 200) {
                setApiStatusCode(200);
                setApiMessage([response.data.message]);
                setSessionId(response.data.data.session_id);
                setisOtpSection(true);
              
            } else {
                setApiStatusCode(false);
                const errorMessage = response.data.message;
                setApiMessage(errorMessage);
               
            }
                setisButtonDisable(false)
                setApiCalled(false);
            
        })
        .catch(error => {
           
            setApiCalled(true);
            setApiStatusCode(false);
            const errorMessage = error.response.data.message;
            setApiMessage(errorMessage);
            setTimeout(() => {
                setApiCalled(false);
                setisButtonDisable(false)
            }, 5000);
        });
    };
    const handleOtpSubmit = async(event) => {
        event.preventDefault();
        const headers = header;
    
        const requestData = {
            otp: otp,
            visp_qualification_id: visp_qualification_id,
            session_id: verificationSessionId
        };
    
        axios.post(`${apiUrl}nbn/customer-registration`, requestData, {
            headers:headers
        })
        .then(response => {
            if (response.status === 200) {
                setApiCalled(true);
                setApiStatusCode(response.data.status);
                setApiMessage([response.data.message]);
    
                setTimeout(() => {
                    setApiCalled(false);
                    onSuccessTap();
                    onActiveSuccess();
                }, 5000);
    
               
            } else {
                setApiCalled(true);
                setApiStatusCode(false);
                const errorMessage = response.data.message;
                setApiMessage(errorMessage);
               
                setTimeout(() => {
                    setApiCalled(false);
                }, 5000);
            }
        })
        .catch(error => {
            setApiCalled(true);
           
            setApiStatusCode(false);
            // const errorMessage = Array.isArray(error.response.data.message) ? error.response.data.message.join(", ") : error.response.data.message;
            const errorMessage = error.response.data.message;
            setApiMessage(errorMessage);
            setTimeout(() => {
                setApiCalled(false);
              }, 5000);
          })
        }
    
    
         
    return (
        <div id="Payment" className="tabcontent">
            <section className="get-plan" style={{ marginTop: '0!important' }}>
                <div className="container" style={{ backgroundColor: '#fff', borderTopLeftRadius: '30px', borderBottomRightRadius: '30px' }}>
                    <form className="contact-form row" autoComplete='off' onSubmit={isOtpSection ? handleOtpSubmit : handleSubmit}>

                        <div className="form-field col-lg-12" style={{ textAlign: 'left' }}>
                            <p style={{ color: '#777', textAlign: 'left' }}>Enter the email address and password customer would like to use to login to Telsim My Account:</p>
                        </div>
                        <div className="form-field col-lg-12">
                            <label className="label" htmlFor="password">Email</label>
                            <input type="email"  autoComplete="off" className="input-text js-input" id="email" name="email" disabled={isOtpSection} value={formData.email} onChange={handleInputChange} required />
                        </div>
                             {/* {emailError && <span style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>} */}
                             
                        <div className="form-field col-lg-12">
                            <label className="label" htmlFor="password">Password</label>
                            <input type="password" autoComplete="new-password"   className="input-text js-input" id="password" name="password" disabled={isOtpSection} value={formData.password} onChange={handleInputChange} required />
                        </div>

                        {isOtpSection ? (
                            <>
                                <div className="form-field col-lg-12">
                                    <label className="label" htmlFor="otp">Enter OTP (6 digits)</label>
                                    <input type="phone" className="input-text js-input" name="otp" maxLength="6" value={otp} required  onChange={(e) => setOtp(e.target.value)} />
                                </div>
                                <span style={{ color: "green" }}>Verification OTP has been sent to customer email address. Please enter the OTP.</span>
                                <div className="row">
                                    <div className="form-field col-lg-6">
                                        <input className="payment-back-btn" type="button" value="BACK" onClick={handleBackClick} />
                                    </div>
                                    <div className="form-field col-lg-6">
                                        <input className="payment-submit-btn" type="submit"  disabled={apiCalled}  value={apiCalled ? 'Loading...' : 'CONTINUE'}/>
                                    </div>
                                </div>
                            </>

                        ) : (
                            <div className="row">
                                <div className="form-field col-lg-6">
                                    <input className="payment-back-btn" type="button" value="BACK" onClick={handleBackClick} />
                                </div>
                                <div className="form-field col-lg-6">
                                    <input className="payment-submit-btn" type="submit" disabled={isButtonDisable} value={isButtonDisable? 'Loading...' : 'CONTINUE'} />
                                </div>
                            </div>
                        )}

                    </form>
                    <br></br>


                     { 
                    apiCalled && apiMessage && (
                        <div className={"alert " + (apiStatus === 200   ? "alert-success" : "alert-danger")}  style={{textAlign:'left'}}>
                            {apiMessage}
                        </div>
                    )
                    }

                   
                </div>
            </section>
        </div>
    );
}

export default OtpVerification;
